export default {
  nav: {
    reserve: 'Book Now',
    cart: 'Cart',
    menu: 'Menu',
    language: 'Language',
    about: "About Us",
    contact: "Contact",
    categories: "Tour categories",
  },
  hero: {
    line1: 'Schooners, trails and adventures in',
    line2: 'Paraty',
    subtitle: 'Schooner tours, private boats, jeep tours and diving.',
    subtitleHighlight: 'Unique experiences',
    ctaTours: 'See Tours',
    ctaContact: 'Contact Us',
    scroll: 'Explore',
    statYears: 'Years of Experience',
    statGuests: 'Happy Passengers',
    statBeaches: 'Beaches & Islands',
  },
  tours: {
    label: 'Our Tours',
    title: 'Discover the best of Paraty',
    subtitle: 'Carefully selected tours for you to enjoy every moment.',
    duration: 'Duration',
    difficulty: 'Difficulty',
    from: 'From',
    details: 'See Details',
    seeAll: 'See all tours',
    limited: 'Limited Spots',
    fewLeft: 'Few left',
    flashDeal: 'Flash Deal',
    offerEnds: 'Offer ends in:',
    offerPrice: 'Offer Price',
    stillOffer: 'Still on offer!',
    categories: {
      all: 'All',
      escunas: 'Schooners',
      jeep: 'Jeep Tours',
      compartilhadas: 'Shared Boats',
      privadas: 'Private Boats & Schooners',
      bolivia: 'Bolivia Expedition 🇧🇴',
    },
  },
  why: {
    label: 'Why choose AQUAMARINA?',
    title: 'An experience beyond the tour',
    pillars: {
      safety: 'Safety first',
      guides: 'Experienced local guides',
      boats: 'Quality vessels',
      price: 'Fair and transparent pricing',
    },
  },
  testimonials: {
    label: 'Testimonials',
    title: 'What our passengers say',
    subtitle: 'Real experiences from those who have sailed with us.',
  },
  faq: {
    label: 'FAQ',
    title: 'Questions & Answers',
    subtitle: 'Everything you need to know before boarding.',
  },
  contact: {
    label: 'Book your adventure',
    title: 'Contact & Reservations',
    subtitle: 'Ready to dive into an unforgettable experience?',
    form: {
      name: 'Full name',
      email: 'Email',
      phone: 'WhatsApp',
      date: 'Tour date',
      message: 'Tell us about your ideal adventure',
      submit: 'Send message',
      sending: 'Sending...',
      successTitle: 'Message sent!',
      successText: 'Our team will contact you soon.',
    },
    location: 'Where we are',
    attendance: 'Customer Service',
    schedule1: 'Monday to Saturday: 8am to 8pm',
    schedule2: 'Sunday: 9am to 5pm',
    email: 'paraty.sirenatours@gmail.com',
    whatsappLabel: 'Quick service',
    address: 'Av. Roberto Silveira 578, Downtown — Paraty, RJ',
    mapLink: 'View on Google Maps',
  },
  bolivia: {
    badge: 'Opening Offer',
    title: 'Discover Bolivia with Us',
    subtitle: 'Explore the largest salt desert in the world, colorful lagoons, volcanoes and otherworldly landscapes in the Bolivian Altiplano.',
    cta: 'Explore the Expedition',
    seeAll: 'See all tours',
    highlights: ['3 Days / 2 Nights', 'Small Group', 'Expert Guide', 'All Inclusive'],
    openingOffer: 'Opening Price',
    promoBadge: 'Promo Price',
    promoPrice: 'Promo Price',
    price: 'R$ 1.200',
    originalPrice: 'R$ 1.500',
    perPerson: 'per person',
    allIncluded: 'All Included',
    includedTitle: 'What\'s included',
    accommodation: '2 Nights Accommodation',
    meals: 'All Meals',
    transport: '4x4 Transport',
    guide: 'Expert Guide',
    sunset: 'Sunset at Salt Flats',
    flamingos: 'Flamingos & Lagoons',
    newActivity: 'NEW ACTIVITY',
    newActivityDesc: 'Bolivian high-altitude wine tasting at sunset',
  },
  footer: {
    rights: 'All rights reserved.',
    company: 'AQUAMARINA TOURS',
    tagline: 'Unique ocean experiences in Paraty',
    links: {
      home: 'Home',
      tours: 'Tours',
      contact: 'Contact',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
    },
  },
  category: {
    back: 'Home',
    emptyTitle: 'No tours found',
    emptyText: 'No tours found in this category at the moment.',
    ctaAll: 'See all tours',
  },
  booking: {
    reserve: 'Book your tour',
    date: 'Tour date',
    adults: 'Adults (10+ years) — Full price',
    children: 'Children (5 to 9 years) — Half price',
    babies: 'Babies (0 to 4 years) — Free',
    adultPrice: 'each',
    childPrice: 'each',
    babyPrice: 'Free',
    total: 'Estimated total',
    addCart: 'Add to cart',
    added: 'Added!',
    cartSuccess: 'Tour added to cart!',
    reserveNow: 'Book now',
    pixTitle: 'How does the reservation work?',
    pixText1: 'To complete the reservation, you need to pay a deposit via PIX.',
    pixText2: 'The remaining payment is made on the day of the tour, directly at the boarding location.',
    pixText3: 'After the deposit payment, we will send the voucher with all the information.',
    whatsappCta: 'Continue reservation via WhatsApp',
    back: 'Back',
    selectDateAlert: 'Please select a date for the tour.',
    whatsappModal: {
      title: 'Confirm Reservation',
      totalTours: 'Total tours',
      totalPeople: 'Total people',
      grandTotal: 'Estimated total',
      priceReference: 'Reference Prices',
      perPerson: 'Per person',
      startingFrom: 'Starting from',
      warningTitle: '⚠️ Attention! Read before continuing',
      warning1: 'You will be redirected to WhatsApp with all tour details, number of people, dates and prices.',
      warning2: 'The PIX deposit amount will be informed by our team on WhatsApp according to the selected tours.',
      warning3: 'The remaining payment is made on the day of the tour, directly at the boarding location.',
      warning4: 'After the deposit payment, we will send the voucher with all your reservation information.',
      acceptTerms: 'I have read and accept. I understand that I will be redirected to WhatsApp to finalize the reservation.',
      acceptAndGo: 'Accept and go to WhatsApp',
      cancel: 'Cancel',
      fullName: 'Your full name',
      fullNamePlaceholder: 'Ex: John Smith',
      nameRequired: 'Please enter your full name to continue.',
    },
  },
  cart: {
    title: 'Your Cart',
    empty: 'Your cart is empty',
    emptyCta: 'Explore tours',
    itemAdults: 'Adults',
    itemChildren: 'Children',
    itemBabies: 'Babies',
    remove: 'Remove',
    total: 'Estimated total',
    continue: 'Continue booking',
    reserveAll: 'Reserve everything via WhatsApp',
  },
  notFound: {
    title: 'Page not found',
    back: 'Back to home',
  },
  tour: {
    about: 'About this tour',
    itinerary: "Day's Itinerary",
    included: "What's included",
    notIncluded: "What's not included",
    bring: 'What to bring',
    info: 'Practical information',
    policy: 'Policy, Terms & Important Notices',
    importantNotes: 'Important notices',
    cancellation: 'Cancellation policy',
    cancellationPolicy: "7 days or more before the tour: 100% refund. Between 7 days and 48 hours before: 20% is withheld (80% refund). Less than 48 hours before, or a no-show: no refund. If we cancel for safety or bad weather: 100% refund.",
    terms: 'Terms and conditions',
    meetingPoint: 'Meeting point',
    startTime: 'Start time',
    duration: 'Duration',
    difficulty: 'Difficulty',
    groupSize: 'Group size',
    related: 'Tours you may also like',
    reviews: 'Real Reviews',
    reviewsSubtitle: 'Testimonials from those who have already lived this experience with AQUAMARINA.',
    back: 'Back',
    tab: {
      descricao: 'Description',
      roteiro: 'Itinerary',
      incluso: "What's included",
      levar: 'What to bring',
      info: 'Information',
      politica: 'Policy',
    },
    gallery: {
      prev: 'Previous image',
      next: 'Next image',
      viewPhoto: 'View photo',
    },
  },
};
